'use strict';

exports.__esModule = true;
exports['default'] = propTypes;
var _validators = require('../../utils/validators');
function propTypes(props) {
  return function (target) {
    (0, _validators.validateClass)(target, 'defaultProps');

    // eslint-disable-next-line
    target.propTypes = props;
  };
}